import React from 'react';
import { useEffect, useState, useRef } from 'react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import '../../scss/project.scss';
import upsort from '../../images/common/upsort.png'
import downsort from '../../images/common/downsort.png'
import edit from '../../images/common/edit.png'
import trash from '../../images/common/trash.png'
import bluedownarrow from '../../images/common/bluedownarrow.png'
import blueuparrow from '../../images/common/blueuparrow.png'
import Sidebar from '../layout/Sidebar';
import { useNavigate, useLocation, useParams} from "react-router-dom";
import getResponse from '../actions/Project';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { parseBreadcrumbsList, parseCloneProject } from '../../store/Actions';
import { useDispatch, useSelector } from 'react-redux';
import editDark from '../../images/common/edit-dark.png';
import trashDark from '../../images/common/trash-dark.png';
import Spinner from '../Reusables/Spinner';
import DeleteItem from '../popups/DeleteItem';
import SearchSection from '../Reusables/SearchSection';
import Pagination from '../Reusables/Pagination';
import RefreshToken from '../actions/RefreshToken';
import Entries from '../Reusables/Entries';
import search from '../../images/common/search.png';
import restore from '../../images/project/restore.png'
import restoreDark from '../../images/project/restore-dark.png'
import { convertToDateString, convertUTCToPST } from '../Reusables/Function';
import Snackbars from '../Reusables/Snackbar';
import Calender from '../Reusables/Calender';
import { VscDebugRestart } from "react-icons/vsc";

function ClickOutside(ref, setFilter) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setFilter(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

const Projects = () => {
    const {project_type} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const filterwrapperRef = useRef(null);
    const isProjectCloned = useSelector((state) => state.isProjectCloned);
    const [filterdetails, setFilter] = useState(false);
    ClickOutside(filterwrapperRef, setFilter);

    const [analytics, setAnalytics] = useState([]);
    const [categorydropdown, setCategorydropdown] = useState(false);
    const [entitydropdown, setEntitydropdown] = useState(false);
    const [taskdropdown, setTaskdropdown] = useState(false);
    const [asssigndropdown, setAssigndropdown] = useState(false);
    const [categorydropdownlist, setCategorydropdownlist] = useState([]);
    const [entitydropdownlist, setEntitydropdownlist] = useState([]);
    const [taskdropdownlist, setTaskdropdownlist] = useState([]);
    const [assigndropdownlist, setAssigndropdownlist] = useState([]);
    const [page, setPage] = useState('1');
    const [deleteproject, setDeleteproject] = useState('');
    const [restoreproject, setRestoreproject] = useState(false);
    const [projectlists, setProjectlists] = useState([]);
    const [totalpage, setTotalPage] = useState(null);
    const [searchstate, setSearch] = useState(false);
    const [sortstate, setSortstate] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [showRestorePopup, setShowRestorePopup] = useState(false);
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [restoreProjectId, setRestoreProjectId] = useState(null);
    const [downloadtype, setDownloadtype] = useState('week');
    const [downloadarray, setDownloadarray] = useState([]);
    const [enable, setEnable] = useState(true);
    const [limit, setLimit] = useState(30);
    const [searchData, setSearchData] = useState(null);
    const [filteredDropdownList, setFilteredDropdownList] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [open, setOpen] = useState(null)
    const [message, setMessage] = useState(null);
    const [startfromdate, setFromStartDate] = useState(false);
    const [starttodate, setToStartDate] = useState(false);
    const [fromlabel, setFromLabel] = useState('From');
    const [tolabel, setToLabel] = useState('To');
    const [mindate, setminDate] = useState(false);
    const [downloadDate, setDownloadDate] = useState({
        from: null,
        to: null
    });

    const params = new URLSearchParams(location.search);
    const sort = params.has('sort') ? (params.get('sort') == "property" ? "entity" : params.get('sort')) : '';
    const sort_order = params.has('sort_order') ? params.get('sort_order') : '';

    const headers = [
        { label: "Project", key: "project" },
        { label: "Property", key: "entity" },
        { label: "Due Date", key: "dueDate" },
        { label: "Resend Date", key: "resendDate" },
        { label: "Current Task", key: "currentTask" },
        { label: "Task Completed", key: "taskCompleted" },
        { label: "Assigned To", key: "assignedTo" },
        { label: "Created Date", key: "createdTime" }
    ];  

    const filename = 'Projects';

    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Projects", "url": "projects/list" }
    ];

    const [searchValues, setSearchValues] = useState({
        isFilter: true,
        isCreate: true,
        placeholder: "Search Project/Property",
    })
    
    function changeImage(index) {
        const id = index
        const Editelement = document.getElementById('edit'+id)
        const Trashelement = document.getElementById('trash'+id)
        const Restoreelement = document.getElementById('restore'+id)
        if(Editelement) Editelement.src = editDark;
        if(Trashelement) Trashelement.src = trashDark
        if(Restoreelement) Restoreelement.src = restoreDark
    }

    function removeImage(index) {
        const id = index
        const Editelement = document.getElementById('edit'+id)
        const Trashelement = document.getElementById('trash'+id)
        const Restoreelement = document.getElementById('restore'+id)
        if(Editelement) Editelement.src = edit;
        if(Trashelement) Trashelement.src = trash;
        if(Restoreelement) Restoreelement.src = restore
    }

    function toCreateNewProject() {
        navigate('/projects/new');
    }

    function NavigateProjectDetails(id) {
        navigate(`/projects/${id}/view`);
    }

    function ProjectReportNavigate() {
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list`);
    }

    function ProjectEditNavigate(event, id) {
        event.stopPropagation();
        navigate(`/projects/${id}/edit`);
    }

    function DeleteProject(event, id) {
        setEnable(true)
        event.stopPropagation();
        setDeleteProjectId(id);
        handleShow();
    }

    function RestoreProject(event, id) {
        event.stopPropagation();
        setRestoreProjectId(id);
        handleShowRestorePopup();
    }

    function HandleChange(page) {
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : ''
        const task = params.has('task') ? params.get('task') : ''
        const entity = params.has('property') ? params.get('property') : ''
        const assigned = params.has('assigned') ? params.get('assigned') : ''
        const category = params.has('category') ? params.get('category') : ''
        const from = params.has('from') ? params.get('from') : ''
        const to = params.has('to') ? params.get('to') : ''

        setPage(page);
        navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=${page}${sort ? `&sort=${sort == "entity" ? "property" : sort}`: ''}`+
        `${sort_order ? `&sort_order=${sort_order}`: ''}${search ? `&search=${search}`: ''}${category ? `&category=${category}` : ''}`+
        `${entity ? `&property=${entity}` : ''}${task ? `&task=${task}`: '' }${assigned ? `&assigned=${assigned}`: '' }`+
        `${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);

        window.scroll(0, 0);
    }

    function CallDeleteApi() {
        setEnable(false)
        const URL = `/api/Project/${deleteProjectId}`;
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.DeleteProject(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        handleClose();
                        setDeleteproject(deleteProjectId);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function CallRestoreApi() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.RestoreProject(restoreProjectId, accesstoken, (response) => {
                    if(response.status == 200) {
                        handleCloseRestorePopup();
                        setRestoreproject(!restoreproject);
                        setMessage("Restored successfully");
                        setOpen(true)
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function CategoryDropdown() {
        setCategorydropdown(!categorydropdown);
    }

    function EntityDropdown() {
        setEntitydropdown(!entitydropdown);
    }

    function TaskDropdown() {
        setTaskdropdown(!taskdropdown);
    }

    function AssignDropdown() {
        setAssigndropdown(!asssigndropdown);
    }

    const GetSortedUsers = (data) => {
        var usersList = data.map((item) => {
            return {...item, name: item.firstName+item.lastName}
        })
        return usersList.sort((a, b) => a.name.localeCompare(b.name));
    }

    function GetEntityParam(entitydropdownlist) {
        const params = new URLSearchParams(location.search);
        const entity = params.get('property');
        console.log("entityload", entity);
        entitydropdownlist.map((item, index) => { 
            if(item.idEntities === Number(entity)) {
                console.log('item.entityName', item.entityName);
                if(document.getElementsByClassName('entity-dropdown-name')[0]) {
                    document.getElementsByClassName('entity-dropdown-name')[0].innerHTML = item.entityName;
                }
            }   
        })      
    }

    function GetAssignedParam(assigndropdownlist) {
        const params = new URLSearchParams(location.search);
        const assigned = params.get('assigned');
        console.log("assigned", assigned);
        assigndropdownlist && assigndropdownlist.length > 0 && assigndropdownlist.map((item, index) => { 
            if(item.idUsers === Number(assigned)) {
                if(item.firstName !== '' && item.firstName !== undefined && item.firstName !== null) {
                    var firstName = item.firstName;
                }
                else {
                    var firstName = '';
                }
                if(item.lastName !== '' && item.lastName !== undefined && item.lastName !== null) {
                    var lastName = item.lastName;
                }
                else {
                    var lastName = '';
                }
                var name = firstName +' '+lastName;
                if(document.getElementsByClassName('assigned-dropdown-name')[0]) {
                    document.getElementsByClassName('assigned-dropdown-name')[0].innerHTML = name;
                }
            }   
        })      
    }

    const callSearchApi = (query) => {
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        setSearch(!searchstate);
        navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${sort ? `&sort=${sort == "entity" ? "property" : sort}`: ''}${sort_order ? `&sort_order=${sort_order}`: ''}&search=${query}`);
    }

    function SortProject(dataset) {
        setSortstate(!sortstate);
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        let sortBy = dataset.sortBy;
        let sortType = dataset.sortType;
        navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${search ? `&search=${search}`: ''}&sort=${sortBy == "entity" ? "property" : sortBy}&sort_order=${sortType}`);
    }

    function Filter(filter, value) {
        let params = new URLSearchParams(location.search);
        let entity = params.has('property') ? params.get('property') : ''
        let assigned = params.has('assigned') ? params.get('assigned') : ''
        let task = params.has('task') ? params.get('task') : ''
        let category = params.has('category') ? params.get('category') : ''
        let from = params.has('from') ? params.get('from') : '';
        let to = params.has('to') ? params.get('to') : '';

        let entityendpoint = `/api/entity/dropdown?${category ? `category=${category}`: '' }${category ? '&' : ''}`+
        `${task ? `task=${task}`: '' }${task ? '&' : ''}${assigned ? `assignedTo=${assigned}`: '' }`;

        let taskendpoint = `/api/project/tasksdropdown?${category ? `category=${category}`: '' }${category ? '&' : ''}${entity ? `entityId=${entity}` : ''}`+
        `${entity ? '&' : ''}${assigned ? `assignedTo=${assigned}`: '' }`

        let assignendpoint = `/api/users/list?${category ? `category=${category}`: '' }${category ? '&' : ''}${entity ? `entityId=${entity}` : ''}`+
        `${entity ? '&' : ''}${task ? `task=${task}`: '' }`

        if(filter == "category") {
            setCategorydropdown(false);
            document.getElementsByClassName('category-dropdown-name')[0].innerHTML = value;
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${(value != "All") ? `&category=${value}`: '' }${entity ? `&property=${entity}`: '' }`+
            `${task ? `&task=${task}`: '' }${assigned ? `&assigned=${assigned}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);

            if(value == "All") {
                entityendpoint = `/api/entity/dropdown?${task ? `task=${task}` : ''}${task ? '&' : ''}${assigned ? `assignedTo=${assigned}` : ''}`
                taskendpoint = `/api/project/tasksdropdown?${task ? `task=${task}` : ''}${task ? '&' : ''}${assigned ? `assignedTo=${assigned}` : ''}`
                assignendpoint = `/api/users/list?isProject=true${task ? `&task=${task}` : ''}${assigned ? `&assignedTo=${assigned}` : ''}`
            } else {
                entityendpoint = `/api/entity/dropdown?category=${value}${task ? `&task=${task}` : ''}${assigned ? `&assignedTo=${assigned}` : ''}`;
                taskendpoint = `/api/project/tasksdropdown?category=${value}${entity ? `&entityId=${entity}` : ''}${assigned ? `&assignedTo=${assigned}` : ''}`
                assignendpoint = `/api/users/list?isProject=true&category=${value}${entity ? `&entityId=${entity}` : ''}${task ? `&task=${task}` : ''}`
            }
        }

        if(filter == "property") {
            setEntitydropdown(false);
            document.getElementsByClassName('entity-dropdown-name')[0].innerHTML = value;
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${category ? `&category=${category}`: '' }${(value != "All") ? `&property=${value.idEntities}`: '' }`+
            `${task ? `&task=${task}`: '' }${assigned ? `&assigned=${assigned}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);

            if(value == "All") {
                taskendpoint = `/api/project/tasksdropdown?${assigned ? `assignedTo=${assigned}` : ''}${assigned ? '&' : ''}${category ? `category=${category}`: '' }`
                assignendpoint = `/api/users/list?isProject=true${task ? `&task=${task}` : ''}${category ? `&category=${category}`: '' }`
            } else {
                taskendpoint = `/api/project/tasksdropdown?entityId=${value.idEntities}${assigned ? `&assignedTo=${assigned}` : ''}${category ? `&category=${category}`: '' }`
                assignendpoint = `/api/users/list?isProject=true&entityId=${value.idEntities}${task ? `&task=${task}` : ''}${category ? `&category=${category}`: '' }`
            }

        } else if(filter == "task") {
            setTaskdropdown(false);
            document.getElementsByClassName('task-dropdown-name')[0].innerHTML = value;
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${category ? `&category=${category}`: '' }${entity ? `&property=${entity}`: '' }`+
            `${(value != "All") ? `&task=${value}`: '' }${assigned ? `&assigned=${assigned}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);

            if(value == "All") {
                entityendpoint = `/api/entity/dropdown?${assigned ? `assignedTo=${assigned}` : ''}${assigned ? '&' : ''}${category ? `category=${category}`: '' }`
                assignendpoint = `/api/users/list?isProject=true${entity ? `&entityId=${entity}` : ''}${category ? `&category=${category}`: '' }`;
            } else {
                entityendpoint = `/api/entity/dropdown?task=${value}${assigned ? `&assignedTo=${assigned}` : ''}${category ? `&category=${category}`: '' }`;
                assignendpoint = `/api/users/list?isProject=true&task=${value}${entity ? `&entityId=${entity}` : ''}${category ? `&category=${category}`: '' }`;
            }

        } else if(filter == "assigned") {
            setAssigndropdown(false);
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${category ? `&category=${category}`: '' }${entity ? `&property=${entity}`: '' }`+
            `${task ? `&task=${task}`: '' }${(value != "All") ? `&assigned=${value.idUsers}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`)

           if(value == "All") {
                document.getElementsByClassName('assigned-dropdown-name')[0].innerHTML = "All";

                entityendpoint = `/api/entity/dropdown?${task ? `task=${task}` : ''}${task ? '&' : ''}${category ? `category=${category}`: '' }`;
                taskendpoint = `/api/project/tasksdropdown?${entity ? `entityId=${entity}` : ''}${entity ? '&' : ''}${category ? `category=${category}`: '' }`;
           } else {
                if(value.firstName !== '' && value.firstName !== undefined && value.firstName !== null) {
                    var firstName = value.firstName;
                }
                else {
                    var firstName = '';
                }
                if(value.lastName !== '' && value.lastName !== undefined && value.lastName !== null) {
                    var lastName = value.lastName;
                }
                else {
                    var lastName = '';
                }
                var name = firstName +' '+lastName;
                    document.getElementsByClassName('assigned-dropdown-name')[0].innerHTML = name;

                entityendpoint = `/api/entity/dropdown?assignedTo=${value.idUsers}${task ? `&task=${task}` : ''}${category ? `&category=${category}`: '' }`;
                taskendpoint = `/api/project/tasksdropdown?assignedTo=${value.idUsers}${entity ? `&entityId=${entity}` : ''}${category ? `&category=${category}`: '' }`;
            };
        } else if(filter == "from") {
            setminDate(value);
            setFromStartDate(value);
            let from = convertToDateString(value, "");
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${category ? `&category=${category}`: '' }${entity ? `&property=${entity}`: '' }`+
            `${task ? `&task=${task}`: '' }${assigned ? `&assigned=${assigned}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        } else if(filter == "to") {
            setToStartDate(value);
            let to = convertToDateString(value, "");
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${category ? `&category=${category}`: '' }${entity ? `&property=${entity}`: '' }`+
            `${task ? `&task=${task}`: '' }${assigned ? `&assigned=${assigned}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        } else if(filter == "dueDate") {
            setminDate(false);
            setFromStartDate(false);
            setToStartDate(false);
            setFromLabel('From');
            setToLabel('To');
            navigate(`/projects${project_type ? `/${project_type}` : ''}/list?page=1${category ? `&category=${category}`: '' }${entity ? `&property=${entity}`: '' }`+
            `${task ? `&task=${task}`: '' }${assigned ? `&assigned=${assigned}`: '' }`);
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                console.log("Filter ", filter)
                if(!filter) setFilter(!filterdetails);

                if(filter != "property") {
                    getResponse.GetEntityDropdown(accesstoken, entityendpoint, (response) => { 
                        if(response.status == 200) {
                            setEntitydropdownlist(response.data.data);
                        } else if(response.status == 401) {
                            navigate("/login")
                        }     
                    });
                }

                if(filter != "task") {
                    getResponse.GetTaskDropdown(accesstoken, taskendpoint, (response) => {
                        if(response.status == 200) {
                            setTaskdropdownlist(response.data.data);
                        } else if(response.status == 401) {
                            navigate("/login")
                        }
                    });
                }

                if(filter != "assigned") {
                    getResponse.GetAssignDropdown(accesstoken, assignendpoint, (response) => {
                        if(response.status == 200) {
                            setAssigndropdownlist(GetSortedUsers(response.data.data));
                        } else if(response.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    useEffect(() => {
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        setCategorydropdownlist([
            "Active",
            "Inactive"
        ])
    }, [])

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    const handleCloseRestorePopup = () => {
        setShowRestorePopup(false);
    }

    const handleShowRestorePopup = () => {
        setShowRestorePopup(true);
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pagenum = params.has('page') ? params.get('page') : 1
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : ''
        const task = params.has('task') ? params.get('task') : ''
        const entity = params.has('property') ? params.get('property') : ''
        const assigned = params.has('assigned') ? params.get('assigned') : ''
        const category = params.has('category') ? params.get('category') : ''
        const from = params.has('from') ? params.get('from') : '';
        const to = params.has('to') ? params.get('to') : '';

        function CallAPI(accesstoken) {
           
            console.log('projecttoken', accesstoken);
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                const downloadURL = `/api/project/page?page=${pagenum}&limit=${limit}${project_type ? `&project_type=${project_type}` : ''}${sort ? `&sort_by=${sort}` : ''}`+
                `${sort_order ? `&sort_type=${sort_order}` : ''}${search ? `&search=${search}` : ''}${category ? `&category=${category}` : ''}${entity ? `&entity=${entity}` : ''}`+
                `${task ? `&current_task=${task}` : ''}${ assigned ? `&assigned_to=${assigned}` : ''}${from ? `&startDate=${from}`: '' }${to ? `&endDate=${to}`: '' }&download=true&type=${downloadtype}${downloadDate.from ? `&downloadFrom=${convertToDateString(downloadDate.from, "")}` : ''}${downloadDate.to ? `&downloadTo=${convertToDateString(downloadDate.to, "")}` : ''}`;

                const listURL = `/api/project/page?page=${pagenum}&limit=${limit}${project_type ? `&project_type=${project_type}` : ''}`+
                `${sort ? `&sort_by=${sort == "property" ? "entity" : sort}` : ''}${sort_order ? `&sort_type=${sort_order}` : ''}`+
                `${search ? `&search=${search}` : ''}${category ? `&category=${category}` : ''}${entity ? `&entity=${entity}` : ''}${task ? `&current_task=${task}` : ''}`+
                `${ assigned ? `&assigned_to=${assigned}` : ''}${from ? `&startDate=${from}`: '' }${to ? `&endDate=${to}`: '' }`;
                // List
                getResponse.GetProjectList(listURL, accesstoken, (response) => {
                    if(response.status == 200) {
                        setTotalPage(response.data.totalPages);
                        setProjectlists(response.data.data);
                        setAnalytics(response.data.analytics);
                        setLoading(false);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });        
                // Download
                console.log("downloadURL", downloadURL);
                getResponse.GetProjectList(downloadURL, accesstoken, (response) => {
                    if(response.status == 200) {
                        var data = response.data.data;
                        var formatedData = formatDateColumns(data);
                        setDownloadarray(formatedData);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));

    }, [page, entitydropdown, taskdropdown, asssigndropdown, deleteproject, searchstate, 
        sortstate, downloadtype, limit, project_type, categorydropdown, restoreproject,
        fromlabel, tolabel, downloadDate])

    const dateColumnKeys = ['dueDate', 'resendDate', 'createdTime'];

    function formatDateColumns(data) {
        const formattedData = data.map((item) => {
            const updatedItem = { ...item };

            dateColumnKeys.forEach((key) => {
                if (key in updatedItem) {
                    if (item[key] === null) {
                        updatedItem[key] = '';
                        return;
                    }
                    const dateValue = new Date(item[key]);
                    updatedItem[key] = convertToDateString(dateValue, 'picker');
                }
            });
            return updatedItem;
        })
        console.log("formattedData", formattedData);
        return formattedData
    }

    const handleEntryDropdown = (value) => {
        setLimit(value);
        HandleChange(1);
    }

    const handleSearchData = (query) => {
        setSearchData(query);
    }

    const handleEnterkey = (key) => {
        if (key == 'Enter') {
            setSearchData(searchData);
        }
    }

    useEffect(() => {
        setFilteredDropdownList(entitydropdownlist);
        setSearchList(entitydropdownlist);
    }, [entitydropdownlist])

    useEffect(() => {
        let suggestions = [];
        if(searchData != null) {
            filteredDropdownList.length > 0 && filteredDropdownList.map((item) => {
                if(item.entityName.toLowerCase().includes(searchData.toLowerCase())) {
                    suggestions.push(item)
                }
            })
            setSearchList(suggestions);
        }
    }, [searchData])

    useEffect(() => {
        if(isProjectCloned) {
            setOpen(true);
            setMessage('Project cloned successfully.');
        }
    }, [isProjectCloned])

    const handleSnackbarClose = (value) => {
        setOpen(value);
        dispatch(parseCloneProject(false));
    }

    return (
        <div className='project-container'>
            <Header />
            <div className='row projects-section'>
                <Sidebar />
                <div className='col-10 project-section-right'>
                    <Breadcrumbs />
                    {isLoading ? 
                    (<Spinner/>) : 
                    (<>
                        <div className='row assigned-search-container project-report-label'>
                            <div className='col-12 project-report'>
                                <div className='project-report-content' onClick={ProjectReportNavigate}>
                                    Project Report
                                </div>
                            </div>
                        </div>
                        <div className='sub-header'>
                            <Entries handleEntryDropdown={handleEntryDropdown} page="Projects"/>
                            <div className='search-details'>
                                <SearchSection values={searchValues} 
                                    handleFilter={Filter} 
                                    setDownloadtype={setDownloadtype} 
                                    downloadtype={downloadtype}
                                    downloadarray={downloadarray} 
                                    callSearchApi={(query) => callSearchApi(query)} 
                                    navigateTo={toCreateNewProject} 
                                    headers={headers} 
                                    filename={filename}
                                    pageType="Projects"
                                    downloadDate={downloadDate} 
                                    setDownloadDate={setDownloadDate}
                                />
                                {filterdetails &&
                                    <>
                                        <div className='filter-details' ref={filterwrapperRef}>
                                            <div className='category-details'>
                                                <div className='category-heading heading'>Category</div>
                                                <div className='category-dropdown dropdown'>
                                                    <div className='category-dropdown-inner dropdown-inner' onClick={CategoryDropdown}>
                                                        <div className='category-dropdown-name dropdown-name'>{new URLSearchParams(location.search).has('category') ? 
                                                        new URLSearchParams(location.search).get('category') : "Active"}</div>
                                                        <img className='arrow' src={categorydropdown ? blueuparrow : bluedownarrow} alt=""></img>
                                                    </div>
                                                    {categorydropdown &&
                                                        <div className='dropdown-content'>
                                                            {/* <div className='dropdown-content-inner' onClick={() => Filter("category", "All")}>All</div> */}
                                                            {
                                                                categorydropdownlist && categorydropdownlist.length > 0 && categorydropdownlist.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            {(item != "" && item != null) && <div className='dropdown-content-inner' key={index} onClick={() => Filter("category", item)}>{item}</div>}
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className='entity-details'>
                                                <div className='entity-heading heading'>Property</div>
                                                <div className='entity-dropdown dropdown'>
                                                    <div className='entity-dropdown-inner dropdown-inner' onClick={EntityDropdown}>
                                                        <div className='entity-dropdown-name dropdown-name'>{new URLSearchParams(location.search).has('property') ? GetEntityParam(entitydropdownlist) : "All"}</div>
                                                        <img className='arrow' src={entitydropdown ? blueuparrow : bluedownarrow} alt=""></img>
                                                    </div>
                                                    {entitydropdown &&
                                                        <>
                                                            <div className='dropdown-search'>
                                                                <div className='dropdown-search-container'>
                                                                    <input type="text" value={searchData} placeholder="Search Property" onChange={(e) => handleSearchData(e.target.value)}
                                                                        onKeyDown={(e) => handleEnterkey(e.key)}></input>
                                                                    <img src={search} alt="searchicon" onClick={() => handleSearchData(searchData)}></img>
                                                                </div>
                                                            </div>
                                                            <div className='dropdown-content'>
                                                                <div className='dropdown-content-inner' onClick={() => Filter("property", "All")}>All</div>
                                                                {
                                                                    searchList && searchList.length > 0 && searchList.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                {(item != "" && item != null) && <div className='dropdown-content-inner' key={index} 
                                                                                onClick={() => Filter("property", item)}>{item.entityName}</div>}
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <div className='task-details'>
                                                <div className='task-heading heading'>Current Task</div>
                                                <div className='task-dropdown dropdown'>
                                                    <div className='task-dropdown-inner dropdown-inner' onClick={TaskDropdown}>
                                                        <div className='task-dropdown-name dropdown-name'>{new URLSearchParams(location.search).has('task') ? new URLSearchParams(location.search).get('task') : "All"}</div>
                                                        <img className='arrow' src={taskdropdown ? blueuparrow : bluedownarrow} alt=""></img>
                                                    </div>
                                                    {taskdropdown &&
                                                        <div className='dropdown-content'>
                                                            <div className='dropdown-content-inner' onClick={() => Filter("task", "All")}>All</div>
                                                            {
                                                                taskdropdownlist && taskdropdownlist.length > 0 && taskdropdownlist.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            {(item != "" && item != null) && <div className='dropdown-content-inner' key={index} 
                                                                            onClick={() => Filter("task", item)}>{item}</div>}
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className='assigned-to-details'>
                                                <div className='assigned-heading heading'>Assigned To</div>
                                                <div className='assigned-dropdown dropdown'>
                                                    <div className='assigned-dropdown-inner dropdown-inner' onClick={AssignDropdown}>
                                                        <div className='assigned-dropdown-name dropdown-name'>{new URLSearchParams(location.search).has('assigned') ? GetAssignedParam(assigndropdownlist) : "All"}</div>
                                                        <img className='arrow' src={asssigndropdown ? blueuparrow : bluedownarrow} alt=""></img>
                                                    </div>
                                                    {asssigndropdown &&
                                                        <div className='dropdown-content'>
                                                            <div className='dropdown-content-inner' onClick={() => Filter("assigned", "All")}>All</div>
                                                            {
                                                                assigndropdownlist && assigndropdownlist.length > 0 && assigndropdownlist.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            {
                                                                                (item != "" && item != null) && 
                                                                                <div className='dropdown-content-inner' key={index} 
                                                                                onClick={() => Filter("assigned", item)}>
                                                                                    {item.firstName && item.firstName}{' '}{item.lastName && item.lastName}
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className='from-due-date'>
                                            <div className="d-flex align-items-center gap-1">
                                                <div className="heading">Due Date</div>
                                                    <VscDebugRestart
                                                    style={{ color: "#059CDC", cursor: "pointer" }}
                                                    size={15}
                                                    onClick={() =>  Filter("dueDate", "reset")}
                                                    strokeWidth={0.5}
                                                    />
                                                </div>
                                                <Calender minDate={false} maxDate={false} startdate={startfromdate} 
                                                    HandleDate={(date) => Filter("from", date)} 
                                                    HandleLabel={(date) => setFromLabel(convertToDateString(date, "picker"))} label={fromlabel}
                                                    disablefromto={false} disableto={false} 
                                                />
                                            </div>
                                            <div className='to-due-date'>
                                                <div className='heading'></div>
                                                <Calender minDate={mindate} maxDate={false} startdate={starttodate} 
                                                    HandleDate={(date) => Filter("to", date)} HandleLabel={(date) => setToLabel(convertToDateString(date, "picker"))} 
                                                    label={tolabel} disablefromto={false} disableto={false}
                                                />
                                            </div>
                                        </div>
                                        <div className='filter-details-arrow'></div>
                                    </>
                                }    
                            </div>
                        </div>
                        <div className='row assigned-search-container'>
                            <div className='col-8 assigned-details'>
                                <div>
                                    <div className='assigned-details-heading'>Assigned To Me</div>
                                    <div className='assigned-details-content'>{analytics.assignedToMe && analytics.assignedToMe}</div>
                                </div>
                                <div>
                                    <div className='assigned-details-heading'>Due Today (Assigned to me)</div>
                                    <div className='assigned-details-content'>{analytics.dueTodayAssignedToMe && analytics.dueTodayAssignedToMe}</div>
                                </div>
                                <div>
                                    <div className='assigned-details-heading'>Total Open</div>
                                    <div className='assigned-details-content'>{analytics.totalOpen && analytics.totalOpen}</div>
                                </div>
                                <div>
                                    <div className='assigned-details-heading'>Due Today</div>
                                    <div className='assigned-details-content'>{analytics.dueToday && analytics.dueToday}</div>
                                </div>
                            </div>
                        </div>
                        <div id="print" className='project-list'>
                            <table>
                                <thead>
                                    <tr className='heading-row'>
                                        <th className='heading-data' style={{minWidth: "30px"}}></th>
                                        <th className='heading-data' style={{minWidth: "150px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Project</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'project' && sort_order === 'asc') && 
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='project' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'project' && sort_order === 'desc') && 
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='project' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "200px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Property</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'entity' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='entity' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'entity' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='entity' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "110px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Due Date</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'duedate' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='duedate' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                    !(sort === 'duedate' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='duedate' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "120px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Resend date</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'resend_date' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='resend_date' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'resend_date' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='resend_date' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "160px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Current Task</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'current_task' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='current_task' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'current_task' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='current_task' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "100px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Task Completed</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'task_completed' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow"  data-sort-by='task_completed' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'task_completed' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='task_completed' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "120px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Assigned To</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'assigned_to' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='assigned_to' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'assigned_to' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='assigned_to' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data' style={{minWidth: "180px", textAlign: "left"}}>
                                            <div className='heading-arrows'>
                                                <div>Created Date</div>
                                                <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'created' && sort_order === 'asc') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='created' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'created' && sort_order === 'desc') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='created' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                </div>
                                            </div>
                                        </th>
                                        <th className='heading-data action-heading' >Actions</th>
                                    </tr>
                                </thead>
                                {
                                    projectlists.length === 0 ? <p className="no-result">No results found</p> :
                                    <tbody>
                                        {projectlists && projectlists.length > 0 && projectlists.map((item, index) => {
                                            return (
                                                <tr className='details-list-row' key={index} style={{color: (item.completedTasks !==0 && item.tasksCount !==0) && item.completedTasks === item.tasksCount ? '#8E8E8E' : '#000000'}} 
                                                onMouseOver={() => changeImage(index)} onMouseLeave={() => removeImage(index)} onClick={() => NavigateProjectDetails(item.idprojects)}>
                                                    <td className='details-list-data marking-data' style={{minWidth: "30px"}}>
                                                        {item.hidden == true ? 
                                                            <div className='marking' style={{background: '#D9D9D9'}}></div> : 
                                                            !(item.completedTasks === item.tasksCount) &&
                                                            <div className='marking' style={{background: item.dueDatePassed === true ? '#E25555' : '#37C30E'}}></div>
                                                        }
                                                    </td>
                                                    <td className='details-list-data text-wrap' style={{minWidth: "150px", maxWidth: "200px"}}>{item.name && item.name}</td>
                                                    <td className='details-list-data details-list-property' style={{minWidth: "200px", maxWidth: "320px"}}>{item.entityString && item.entityString}</td>
                                                    <td className='details-list-data' style={{minWidth: "110px"}}>{item.dueDate && convertToDateString(new Date(item.dueDate), "picker")}</td>
                                                    <td className='details-list-data' style={{minWidth: "120px"}}>{item.resendDate ? convertToDateString(new Date(item.resendDate), "picker") : '-'}</td> 
                                                    {(item.completedTasks === 0 && item.tasksCount === 0) &&
                                                        <td className='details-list-data' style={{minWidth: "140px"}}>No Tasks</td>
                                                    }
                                                    {!(item.completedTasks === 0 && item.tasksCount === 0) &&
                                                        <td className='details-list-data text-wrap' style={{minWidth: "140px", maxWidth: "220px"}}>{item.currentWorkingTask ? item.currentWorkingTask['name'] : "No Tasks"}</td>
                                                    }
                                                     <td className='details-list-data' style={{minWidth: "100px"}}>{`${item.completedTasks ? item.completedTasks : 0} of ${item.tasksCount ? item.tasksCount : 0}`}</td>
                                                    <td className='details-list-data text-wrap' style={{minWidth: "120px"}}>{item.assignedToNavigation ? ((item.assignedToNavigation['firstName'] != null) ? item.assignedToNavigation['firstName'] : '') +' '+((item.assignedToNavigation['lastName'] != null) ? item.assignedToNavigation['lastName'] : '') : 'Not Assigned'}</td>
                                                    <td className='details-list-data' style={{minWidth: "180px"}}>{item.createdTime && convertUTCToPST(item.createdTime + 'Z', "updates")}</td>
                                                    <td className='details-list-data action' >
                                                        {item.hidden == true ? 
                                                        <>
                                                            <img id={'restore'+index} className='restore' src={restore} alt="restore" onClick={(e) => RestoreProject(e, item.idprojects)}></img> 
                                                        </> : 
                                                        <>
                                                            <img id={'edit'+index} className='edit' src={edit} alt="edit" onClick={(e) => ProjectEditNavigate(e, item.idprojects)}></img>
                                                            <img id={'trash'+index} className='trash' src={trash} alt="delete" onClick={(e) => DeleteProject(e, item.idprojects)}></img>
                                                        </>}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                }
                            </table>
                        </div>
                        <div className='pagination'>
                            <Pagination page={page} setPage={setPage} totalpage={totalpage} HandleChange={HandleChange}/>
                        </div>
                    </>)}
                </div>
            </div>
            <Footer />

            {/* Showing delete popup */}
            <DeleteItem show={show} handleClose={handleClose} deleteApiCall={CallDeleteApi} enable={enable}/>

            {/* Showing restore popup */}
            <DeleteItem show={showRestorePopup} handleClose={handleCloseRestorePopup} deleteApiCall={CallRestoreApi} 
            enable={true} type="restore"/>

            <Snackbars error="" open={open} setOpen={(value) => handleSnackbarClose(value)} severity="success" message={message}/>
        </div>
    );
};

export default Projects;